<template>
    <v-hover v-slot="{ hover }">
        <v-card
            :id="
                post.slug && post.slug[$i18n.locale]
                    ? post.slug[$i18n.locale].current
                    : ''
            "
            class="card--flex-vertical, card--featuredProfiles, pa-1"
            :elevation="hover ? 12 : 2"
        >
            <nuxt-link :to="getCustomLocalePath(post)" prefetch>
                <EmbedSanityImage
                    v-if="post.sanityLogo && post.sanityLogo.selectedImage"
                    :selectedImage="
                        post.sanityLogo && post.sanityLogo.selectedImage
                    "
                    :alt="fallbackImage(post, 'alt', $i18n.locale, 'logo')"
                    :height="`220`"
                    :width="`300`"
                    :classes="`d-flex align-end ${
                        !post.logo.imageId || !post.logo.imageDir
                            ? 'blue-circle'
                            : ''
                    } justify-center`"
                    :img-classes="`card-img--featuredTestimonials`"
                    :image-align="`none`"
                    fit="fill"
                />
            </nuxt-link>
        </v-card>
    </v-hover>
</template>
<script>
import colorUtilities from '~/mixins/colorUtilities'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import serializers from '~/util/sanity/serializers'
export default {
    name: 'CardSingleTestimonial',
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
    },
    mixins: [colorUtilities],
    props: {
        post: {
            type: Object,
            default: null,
        },
        imgCrop: {
            type: String,
            default: 'fit',
        },
    },
    data() {
        return {
            serializers,
        }
    },
    methods: {
        fallbackImage(post, part, lang, imgType) {
            const fallback = {
                imageId: 'c3controls-icon',
                imageDir: 'logos',
                alt: { en: 'c3controls', es: 'c3controls' },
            }
            const changeLandingPage =
                (post.changeLandingPage &&
                    post.setLandingPage &&
                    post.setLandingPage.thumbnail) ||
                false
            const thumb = changeLandingPage
                ? post.setLandingPage.thumbnail
                : post[imgType]
            if (thumb && thumb.imageId && thumb.imageDir) {
                if (part === 'imageId') {
                    return thumb.imageId
                } else if (part === 'imageDir') {
                    return thumb.imageDir
                } else if (part === 'alt') {
                    return thumb.alt || fallback.alt
                }
            }
            return fallback[part] || null
        },
    },
}
</script>
